import React from 'react';
import '../Filters/Filters.scss';
import { DATE_WITH_IN } from '../../constants/constants';
import SingleSelectFilter from './SingleSelectFilter';

const RelativeDateFilter = ({
    label,
    name = '',
    field,
    onChange,
    setFiltersConditions,
    filtersConditions,
    repoFilters,
    onBlur
}) => {

    return (
        <div className="filter-control">
            {label && <label className="filter-label">{label}</label>}
            <div className="date-range-container">
                <SingleSelectFilter
                    value={filtersConditions[`${field.fieldName}RelDate`]}
                    options={DATE_WITH_IN}
                    isClearable={false}
                    onChange={(value) => {
                        // Use the new handleConditionChange function if available
                        if (typeof setFiltersConditions === 'function' && setFiltersConditions.name !== 'bound dispatchAction') {
                            setFiltersConditions(`${field.fieldName}RelDate`, value);
                        } else {
                            // Fallback to original behavior
                            setFiltersConditions?.((prev) => ({
                                ...prev,
                                [`${field.fieldName}RelDate`]: value,
                            }));
                        }
                    }}
                    placeholderText="Select..."
                />
                <div>
                    <input
                        type="number"
                        className="filter-input"
                        value={repoFilters[`${field.fieldName}RelDateVal`] || ''}
                        onChange={(e) =>
                            onChange?.(
                                `${field.fieldName}RelDateVal`,
                                e.target.value
                            )}
                        onBlur={onBlur}
                        name={name}
                    />
                </div>
            </div>
        </div>
    );
};

export default RelativeDateFilter;
